export * from './lib/definitions';
export {
  TapClientInterface,
  ProtocolChangeEvent,
} from './lib/tap-client.interface';

export * from './lib/converter/definitions';

export { ResultCode } from './lib/result-code';

export * from './lib/generated/models';
// import { TapRequestFrame } from './lib/generated/models';

// export const MethodType = TapRequestFrame.MethodType;
